var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 181,
    viewBox: "0 0 180 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 158.865C48 159.886 51.5121 160.864 57.7637 161.585C64.0153 162.307 72.4943 162.712 81.3354 162.712C90.1765 162.712 98.6555 162.307 104.907 161.585C111.159 160.864 114.671 159.886 114.671 158.865C114.671 157.845 111.159 156.867 104.907 156.146C98.6555 155.424 90.1765 155.019 81.3354 155.019C72.4943 155.019 64.0153 155.424 57.7637 156.146C51.5121 156.867 48 157.845 48 158.865Z",
    fill: "#D8D8D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.779 20.4627H2V8.15423C2.00451 6.52384 2.65401 4.96147 3.80665 3.80837C4.95929 2.65528 6.5214 2.00516 8.15179 2H146.622C148.253 2.00451 149.816 2.65435 150.969 3.80752C152.122 4.96068 152.772 6.52342 152.776 8.15423L152.779 20.4627Z",
    fill: "white",
    stroke: "#3B4C53",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15137 11.2312C8.15137 12.0473 8.47556 12.8299 9.05263 13.407C9.6297 13.9841 10.4124 14.3083 11.2285 14.3083C12.0446 14.3083 12.8273 13.9841 13.4043 13.407C13.9814 12.8299 14.3056 12.0473 14.3056 11.2312C14.3056 10.4151 13.9814 9.63239 13.4043 9.05532C12.8273 8.47825 12.0446 8.15405 11.2285 8.15405C10.4124 8.15405 9.6297 8.47825 9.05263 9.05532C8.47556 9.63239 8.15137 10.4151 8.15137 11.2312Z",
    fill: "#F2F9FF",
    stroke: "#3B4C53",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.46 11.2312C20.46 11.6353 20.5396 12.0354 20.6942 12.4087C20.8488 12.7821 21.0755 13.1213 21.3612 13.407C21.647 13.6928 21.9862 13.9194 22.3595 14.0741C22.7328 14.2287 23.133 14.3083 23.5371 14.3083C23.9412 14.3083 24.3413 14.2287 24.7146 14.0741C25.088 13.9194 25.4272 13.6928 25.7129 13.407C25.9987 13.1213 26.2253 12.7821 26.38 12.4087C26.5346 12.0354 26.6142 11.6353 26.6142 11.2312C26.6142 10.8271 26.5346 10.4269 26.38 10.0536C26.2253 9.68027 25.9987 9.34106 25.7129 9.05532C25.4272 8.76958 25.088 8.54292 24.7146 8.38828C24.3413 8.23364 23.9412 8.15405 23.5371 8.15405C23.133 8.15405 22.7328 8.23364 22.3595 8.38828C21.9862 8.54292 21.647 8.76958 21.3612 9.05532C21.0755 9.34106 20.8488 9.68027 20.6942 10.0536C20.5396 10.4269 20.46 10.8271 20.46 11.2312Z",
    fill: "#F2F9FF",
    stroke: "#3B4C53",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7686 11.2312C32.7686 12.0473 33.0928 12.8299 33.6698 13.407C34.2469 13.9841 35.0296 14.3083 35.8457 14.3083C36.6618 14.3083 37.4445 13.9841 38.0215 13.407C38.5986 12.8299 38.9228 12.0473 38.9228 11.2312C38.9228 10.4151 38.5986 9.63239 38.0215 9.05532C37.4445 8.47825 36.6618 8.15405 35.8457 8.15405C35.0296 8.15405 34.2469 8.47825 33.6698 9.05532C33.0928 9.63239 32.7686 10.4151 32.7686 11.2312Z",
    fill: "#F2F9FF",
    stroke: "#3B4C53",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M152.778 118.93C152.774 120.561 152.124 122.124 150.971 123.277C149.818 124.43 148.255 125.08 146.624 125.085H8.15374C6.52335 125.079 4.96124 124.429 3.80861 123.276C2.65597 122.123 2.00646 120.561 2.00195 118.93V20.4626H152.781L152.778 118.93Z",
    fill: "#6AA8EE",
    stroke: "#3B4C53",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M121.11 130.505L129.973 121.643L145.481 137.152L136.619 146.014L121.11 130.505Z",
    fill: "white",
    stroke: "#3B4C53",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M175.603 175.721L175.178 176.143C173.466 177.842 171.153 178.795 168.741 178.795C166.33 178.795 164.016 177.842 162.305 176.143L134.325 148.161C133.759 147.591 133.44 146.82 133.44 146.017C133.44 145.213 133.759 144.442 134.325 143.873L143.329 134.866C143.9 134.3 144.671 133.983 145.475 133.983C146.279 133.983 147.05 134.3 147.62 134.866L175.603 162.848C176.45 163.692 177.123 164.695 177.582 165.8C178.041 166.904 178.277 168.088 178.277 169.284C178.277 170.481 178.041 171.665 177.582 172.769C177.123 173.874 176.45 174.877 175.603 175.721Z",
    fill: "#3B4C53",
    stroke: "#3B4C53",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4359 121.803C60.9418 132.435 71.4047 140.047 83.5228 142.964C95.6409 145.882 108.422 143.866 119.053 137.36C129.685 130.854 137.297 120.391 140.214 108.273C143.131 96.1546 141.115 83.3739 134.61 72.7422C128.104 62.1105 117.641 54.4987 105.523 51.5814C93.4045 48.664 80.6238 50.68 69.9921 57.186C59.3604 63.6919 51.7486 74.1547 48.8313 86.2729C45.9139 98.391 47.93 111.172 54.4359 121.803Z",
    fill: "white",
    stroke: "#3B4C53",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M121.109 70.6887C126.371 75.9475 129.955 82.6488 131.408 89.9449C132.861 97.241 132.118 104.804 129.272 111.678C126.426 118.551 121.606 124.426 115.42 128.56C109.235 132.694 101.963 134.9 94.5233 134.9C87.0839 134.9 79.8116 132.694 73.6263 128.56C67.4409 124.426 62.6205 118.551 59.7746 111.678C56.9288 104.804 56.1854 97.241 57.6385 89.9449C59.0916 82.6488 62.6759 75.9475 67.938 70.6887C74.9904 63.6408 84.5528 59.6816 94.5233 59.6816C104.494 59.6816 114.056 63.6408 121.109 70.6887Z",
    fill: "#DBE8F6",
    stroke: "#3B4C53",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3223 111.099C78.324 107.634 81.2098 104.761 84.685 102.776C88.1601 100.791 92.1 99.764 96.102 99.8C100.104 99.836 104.025 100.934 107.464 102.981C110.902 105.029 113.736 107.952 115.675 111.453",
    stroke: "#3B4C53",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9053 80.3838L89.6067 89.0852",
    stroke: "#3B4C53",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9053 89.0852L89.6067 80.3838",
    stroke: "#3B4C53",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M100.419 80.3838L109.12 89.0852",
    stroke: "#3B4C53",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M100.419 89.0852L109.12 80.3838",
    stroke: "#3B4C53",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M145.584 65.5677C145.125 65.458 144.716 65.1968 144.423 64.8261C144.131 64.4555 143.972 63.997 143.972 63.5248C143.972 63.0526 144.131 62.5941 144.423 62.2235C144.716 61.8528 145.125 61.5916 145.584 61.4819L165.476 56.7002C165.784 56.6261 166.105 56.6228 166.415 56.6905C166.725 56.7582 167.016 56.8951 167.265 57.0911C167.515 57.287 167.717 57.5368 167.856 57.8219C167.995 58.1069 168.068 58.4197 168.069 58.737L168.099 68.3004C168.1 68.6186 168.028 68.9328 167.89 69.2194C167.752 69.506 167.551 69.7574 167.301 69.9547C167.051 70.1521 166.76 70.2901 166.45 70.3585C166.139 70.4269 165.817 70.4238 165.507 70.3494L145.584 65.5677Z",
    fill: "white",
    stroke: "#3B4C53",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M129.358 48.756C128.955 48.9989 128.483 49.0996 128.016 49.0421C127.549 48.9846 127.115 48.7722 126.783 48.4389C126.451 48.1055 126.24 47.6705 126.185 47.2033C126.129 46.7362 126.232 46.2639 126.476 45.862L141.486 21.355C141.651 21.0845 141.876 20.8549 142.143 20.6836C142.41 20.5123 142.712 20.4037 143.027 20.3658C143.342 20.328 143.661 20.362 143.961 20.4652C144.261 20.5684 144.533 20.7382 144.758 20.9618L154.283 30.4301C154.508 30.6545 154.68 30.9272 154.785 31.2276C154.889 31.528 154.925 31.8483 154.888 32.1643C154.851 32.4803 154.743 32.7838 154.572 33.0519C154.4 33.3201 154.171 33.5459 153.899 33.7123L129.358 48.756Z",
    fill: "white",
    stroke: "#3B4C53",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M109.251 35.7506C109.141 36.2094 108.879 36.6176 108.508 36.9095C108.137 37.2015 107.679 37.3603 107.207 37.3603C106.735 37.3603 106.277 37.2015 105.906 36.9095C105.536 36.6176 105.274 36.2094 105.163 35.7506L100.384 15.8592C100.309 15.5507 100.306 15.2293 100.373 14.9192C100.441 14.6091 100.578 14.3183 100.774 14.0687C100.97 13.8191 101.22 13.6172 101.505 13.4781C101.79 13.339 102.103 13.2664 102.421 13.2656L111.982 13.2339C112.3 13.2329 112.615 13.3042 112.902 13.4425C113.188 13.5807 113.44 13.7824 113.638 14.0321C113.835 14.2819 113.974 14.5733 114.042 14.8843C114.111 15.1953 114.108 15.5178 114.033 15.8275L109.251 35.7506Z",
    fill: "white",
    stroke: "#3B4C53",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4399 37.8252C84.6872 38.2275 84.7916 38.7014 84.7365 39.1704C84.6813 39.6394 84.4696 40.0761 84.1357 40.4101C83.8018 40.744 83.365 40.9556 82.896 41.0108C82.427 41.066 81.9531 40.9615 81.5508 40.7142L57.0462 25.7072C56.7756 25.5414 56.5461 25.3166 56.3748 25.0495C56.2035 24.7824 56.0948 24.4799 56.057 24.1649C56.0192 23.8498 56.0531 23.5303 56.1564 23.2302C56.2596 22.9302 56.4294 22.6574 56.653 22.4323L66.1188 12.9079C66.3433 12.6824 66.616 12.5108 66.9164 12.4059C67.2168 12.3011 67.537 12.2659 67.853 12.3028C68.169 12.3397 68.4725 12.4478 68.7407 12.6191C69.0088 12.7903 69.2346 13.0201 69.4011 13.2913L84.4399 37.8252Z",
    fill: "white",
    stroke: "#3B4C53",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/notFound.3030fa8528471bcea8e717aa36c2ab1e.svg";
export { ForwardRef as ReactComponent };